import { Button, Chip, Skeleton, Spacer } from "@heroui/react"
import { Column, Row } from "../../../components/Layout"
import TextLabel from "../../../components/typography/TextLabel"
import TextHero from "../../../components/typography/TextHero"
import { Box } from "@mui/material"
import WarningTooltip from "../../../components/WarningTooltip"
import WarningIcon from '@mui/icons-material/Warning';
import CircleIcon from '@mui/icons-material/Circle';

interface JobsCountersProps {
    total: number | null
    new: number | null
    closed: number | null
    loading: boolean
    compact?: boolean
}

export default function AdvertsCounters({ total, new: newCount, closed, loading, compact }: JobsCountersProps) {

    const _totalText = total != null ? total : "-"
    const _newText = newCount != null ? newCount : "-"
    const _closedText = closed != null ? closed : "-"

    const hasNewJobs = (newCount != null && newCount > 0)
    const hasClosedJobs = (closed != null && closed > 0)

    const showTip = (total != newCount) && hasNewJobs && hasClosedJobs && (newCount == closed) && (closed >= 10) && (newCount >= 10)
    // const showTip = true

    return (
        <Row position={"relative"}>
            <Column className="w-4/12" alignItems={"center"}>
                <TextLabel>Total</TextLabel>
                <Skeleton className="rounded-lg" isLoaded={!loading}>
                    {
                        loading ? <Chip><TextHero>{_totalText}</TextHero> </Chip> :
                            compact ?
                                <TextHero>{_totalText}</TextHero> :
                                <span>{_totalText}</span>
                    }
                </Skeleton>
            </Column>
            <Column className="w-4/12" alignItems={"center"}>
                <TextLabel>New</TextLabel>
                <Skeleton className="rounded-lg" isLoaded={!loading}>
                    <Chip color={hasNewJobs ? 'success' : 'default'} variant={hasNewJobs ? 'solid' : 'flat'} radius="full">
                        {compact ? <TextHero>{_newText}</TextHero> : <span>{_newText}</span>}
                    </Chip>
                </Skeleton>
            </Column>
            <Column className="w-4/12" alignItems={"center"}>
                <TextLabel>Closed</TextLabel>
                <Skeleton className="rounded-lg" isLoaded={!loading}>
                    <Chip color={hasClosedJobs ? 'danger' : 'default'} variant={hasClosedJobs ? 'solid' : 'flat'} radius="full">
                        {compact ? <TextHero>{_closedText}</TextHero> : <span>{_closedText}</span>}
                    </Chip>
                </Skeleton>
            </Column>
            {
                showTip && (
                    <Box className="animate-pulse" sx={{
                        position: "absolute",
                        top: "50%",
                        left: "-28px",
                        transform: "translateY(-50%)",
                    }}>
                        <WarningTooltip maxWidth={320} content={
                            <div>
                                <div style={{ textAlign: "initial" }}>
                                    This indicator
                                    <WarningIcon style={{ fontSize: "1rem", opacity: "0.75", color: "yellow", margin: "0 4px" }} />
                                    appears when:
                                </div>

                                <Box color={"rgba(255,255,255,1)"} my={2} px={2}>
                                    <ul>
                                        <li>
                                            {/* <CheckIcon style={{ fontSize: "1rem", opacity: "0.75", color: "green", marginRight: "4px" }} /> */}
                                            <CircleIcon style={{ fontSize: "0.5rem", marginRight: "4px" }} />
                                            <i>The number of

                                                <Button
                                                    style={{ transform: "scale(0.8)" }}
                                                    radius="full"
                                                    size="sm"
                                                    color={"danger"}>Closed
                                                </Button>
                                                and

                                                <Button
                                                    style={{ transform: "scale(0.8)" }}
                                                    radius="full"
                                                    size="sm"
                                                    color={"success"}>New
                                                </Button>

                                                jobs  <b>are the same</b>.</i></li>
                                        <Spacer y={3} />
                                        <div style={{ textAlign: "center" }}><b>And</b></div>
                                        <Spacer y={3} />
                                        <li>  <CircleIcon style={{ fontSize: "0.5rem", marginRight: "4px" }} /><i>The number of new and closed jobs found are <b>both greater than 10</b></i>.</li>
                                    </ul>
                                </Box>

                                <Spacer y={5} />

                                When this happens, it is likely that <b>the same job listings were found, but only listed under different locations</b>.

                            </div>
                        } />
                    </Box>
                )
            }
        </Row>
    )

}